import { Parser } from "hot-formula-parser";

export const parser = new Parser();
